export const countryAssets = {
    DEFAULT: {
        mainBanner: [
            "images/vedette/first-default-vedette.png",
            "images/vedette/second-default-vedette.png",
        ],
        pubBanners: [
            "images/banner/first-default-banner.png",
            "images/banner/second-default-banner.png",
        ],
        smallBanners: []
    },

    TG: {
        mainBanner: [
            "images/vedette/first-tg-vedette.png",
            "images/vedette/second-tg-vedette.png",
        ],
        pubBanners: [
            "images/banner/first-tg-banner.png",
            "images/banner/second-tg-banner.png",
        ],
        smallBanners: [
            "images/presentation_images/tg-vedette1.png",
            "images/presentation_images/tg-vedette2.png",
            "images/presentation_images/tg-vedette3.png",
            "images/presentation_images/tg-vedette4.png",
        ]
    },

    GH: {
        mainBanner: [
            "images/vedette/first-gh-vedette.png",
            "images/vedette/second-gh-vedette.png",
        ],
        pubBanners: [
            "images/banner/first-gh-banner.png",
            "images/banner/second-gh-banner.png",
        ],
        smallBanners: [
            "images/presentation_images/gh-vedette1.png",
            "images/presentation_images/gh-vedette2.png",
            "images/presentation_images/gh-vedette3.png",
            "images/presentation_images/gh-vedette4.png",
        ]
    },
    CI: {
        mainBanner: [
            "images/vedette/first-ci-vedette.png",
            "images/vedette/second-ci-vedette.png",
        ],
        pubBanners: [
            "images/banner/first-ci-banner.png",
            "images/banner/second-ci-banner.png",
        ],
        smallBanners: [
            "images/presentation_images/ci-vedette1.png",
            "images/presentation_images/ci-vedette2.png",
            "images/presentation_images/ci-vedette3.png",
            "images/presentation_images/ci-vedette4.png",
        ]
    },

    SN: {
        mainBanner: [
            "images/vedette/first-sn-vedette.png",
            "images/vedette/second-sn-vedette.png",
        ],
        pubBanners: [
            "images/banner/first-sn-banner.png",
            "images/banner/second-sn-banner.png"
        ],
        smallBanners: [
            "images/presentation_images/sn-vedette1.png",
            "images/presentation_images/sn-vedette2.png",
            "images/presentation_images/sn-vedette3.png",
            "images/presentation_images/sn-vedette4.png",
        ]
    },

    BJ: {
        mainBanner: [
            "images/vedette/first-bj-vedette.png",
            "images/vedette/second-bj-vedette.png",
        ],
        pubBanners: [
            "images/banner/first-bj-banner.png",
            "images/banner/second-bj-banner.png"
        ],
        smallBanners: [
            "images/presentation_images/bj-vedette1.png",
            "images/presentation_images/bj-vedette2.png",
            "images/presentation_images/bj-vedette3.png",
            "images/presentation_images/bj-vedette4.png",
        ]
    },

    NG: {
        mainBanner: [
            "images/vedette/first-ng-vedette.png",
            "images/vedette/second-ng-vedette.png",
        ],
        pubBanners: [
            "images/banner/first-ng-banner.png",
            "images/banner/second-ng-banner.png"
        ],
        smallBanners: [
            "images/presentation_images/ng-vedette1.png",
            "images/presentation_images/ng-vedette2.png",
            "images/presentation_images/ng-vedette3.png",
            "images/presentation_images/ng-vedette4.png",
        ]
    },

    CM: {
        mainBanner: [
            "images/vedette/first-cm-vedette.png",
            "images/vedette/second-cm-vedette.png",
        ],
        pubBanners: [
            "images/banner/first-cm-banner.png",
            "images/banner/second-cm-banner.png"
        ],
        smallBanners: [
            "images/presentation_images/cm-vedette1.png",
            "images/presentation_images/cm-vedette2.png",
            "images/presentation_images/cm-vedette3.png",
            "images/presentation_images/cm-vedette4.png",
        ]
    }
};